<template>
  <div class="wrapper">
    <div class="product-title">
      <h2 class="product-title-font">
        {{ product.title }}
      </h2>
    </div>
    <div class="product-description">
      <p>{{ getDescription(product.description) }}</p>
    </div>
    <div class="sizes">
      <div
        v-for="(item, index) in possibleSizes"
        :key="index"
        class="sizes-box card card-size"
        :class="{
          'card-size-inactive': item.amount < 1,
          'card-size-checked': size === item.size,
          invalidSize: sizeError,
        }"
        @click="setSize(item.size)"
      >
        <div class="card-body">
          {{ item.size.toUpperCase() }}
        </div>
      </div>
    </div>
    <div class="price">
      <p>{{ product.price }} PLN</p>
    </div>

    <div class="buy-section">
      <button
        v-if="productAvailable && !(numberOfProductsInSize < 1 && size)"
        class="btn btn-secondary button-buy"
        @click="addToCartHandler()"
      >
        {{ strings.productPage.addToCart_ }}
      </button>
      <div
        v-else
      >
        <input
          id="inputEmail"
          v-model="email"
          type="email"
          class="form-control margin-bottom-15"
          :class="{ 'is-invalid': error }"
          placeholder="Email"
          required
        >
        <span
          v-if="error"
          class="alert text-danger"
        >{{ strings.productPage.incorrectEmail_ }}</span>
        <button
          v-else
          class="btn btn-secondary button-buy"
          @click="addToWaitingList()"
        >
          {{ strings.productPage.notify_ }}!
        </button>
      </div>
    </div>
    <div class="images">
      <div class="active-image">
        <div
          class="change-image-left"
          @click="changeMainImage(true)"
        />
        <div
          class="change-image-right"
          @click="changeMainImage(false)"
        />
        <div
          class="change-image-left-mobile"
          @touchstart="changeMainImage(true)"
        />
        <div
          class="change-image-right-mobile"
          @touchstart="changeMainImage(false)"
        />
        <img
          :src="getImagePath(mainPicture)"
          alt=""
        >
      </div>
      <div class="all-images">
        <div
          v-for="(image, index) in product.photos"
          :key="index"
          class="one-image-wrapper"
        >
          <img
            :src="getImagePath(image)"
            alt=""
            @mouseover="handleImageShow(image)"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-parsing-error */
import { mapActions, mapGetters } from 'vuex'
import utils from '@/helpers/utils'

export default {
  name: 'ProductPage',
  data () {
    return {
      product: {},
      email: '',
      error: false,
      mainPicture: '',
      size: null,
      sizeError: false,
      numberOfProductsInSize: 0,
      productAvailable: false
    }
  },
  computed: {
    ...mapGetters(['allProducts', 'strings']),
    possibleSizes () {
      return this.product.amount
    }
  },
  mounted () {
    // document.getElementById('main-loader').style.display = 'block'
    this.product = this.allProducts.find(
      (product) => product.title === this.$route.params.name
    )
    this.mainPicture = this.product.mainPhoto
    this.product.photos.sort((a, b) => a.localeCompare(b))
    this.product.photos = [this.mainPicture, ...this.product.photos]
    this.checkIfProductAvailable()
  },
  methods: {
    ...mapActions(['addToCart']),
    getImagePath (productImgPath) {
      return utils.getImagePath(productImgPath)
    },
    async addToWaitingList () {
      try {
        const data = {
          email: this.email,
          product: this.product._id,
          size: this.size
        }
        await this.$store.dispatch('addToWaitingList', data)
        this.$message(
          this,
          this.strings.productPage.added_,
          `${this.strings.productPage.notifyMsg1_}: 
            ${this.email}. ${this.strings.productPage.notifyMsg2_}`,
          'success'
        )
      } catch (e) {
        this.$message(
          this,
          this.strings.productPage.error_,
          this.strings.productPage.notAdded_,
          'danger'
        )
      }
    },
    handleImageShow (image) {
      this.mainPicture = image
    },
    changeMainImage (goBack = false) {
      const index = this.product.photos.indexOf(this.mainPicture)
      let nextIndex = 0
      if (goBack) {
        if (index === 0) nextIndex = this.product.photos.length - 1
        else nextIndex = index - 1
      } else {
        if (index === this.product.photos.length - 1) nextIndex = 0
        else nextIndex = index + 1
      }
      this.mainPicture = this.product.photos[nextIndex]
    },
    setSize (size) {
      this.sizeError = false
      this.size = size
      this.checkIfSizeAvailable(size)
    },
    addToCartHandler () {
      if (this.product && this.size && this.size !== '') {
        const data = {
          product: this.product,
          size: this.size
        }
        this.addToCart(data)
      } else {
        this.sizeError = true
      }
    },
    checkIfProductAvailable () {
      this.product.amount.forEach((element) => {
        if (element.amount > 0) {
          this.productAvailable = true
        }
      })
    },
    checkIfSizeAvailable (size) {
      this.numberOfProductsInSize = this.product.amount.find(item => item.size === size).amount
    },

    getDescription (desc) {
      let description = ''
      desc?.split(';').forEach(d => {
        description += d
        description += '\n'
      })

      return description
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0;
  grid-template-rows: calc(90vh - 80px) 10vh 10vh 15vh 15vh auto;
  grid-row-gap: 10px;
  width: 100%;
}
.product-title {
  grid-column: 1 / 5;
  grid-row: 2;
  padding-top: 15px;
  padding-left: 15px;
  font-size: 1.4rem;
  text-align: left;
  color: #000000;
  font-weight: bold;
  letter-spacing: 3px;
  text-transform: uppercase;
}
.product-title-font {
  font-size: 1.4rem;
}
.product-description {
  grid-column: 1 / 5;
  grid-row: 6;
  color: #000000;
  text-align: left;
  letter-spacing: 1.5px;
  padding: 7px;
  text-align: justify;
  white-space: pre-line;
}
.sizes {
  grid-column: 1 / 5;
  grid-row: 4;
  padding: 5px;
  color: #000000;
}
.price {
  grid-column: 1 / 5;
  grid-row: 3;
  padding-left: 15px;
  font-size: 1.4rem;
  text-align: left;
  color: #000000;
  font-weight: bold;
  letter-spacing: 2px;
}
.buy-section {
  grid-column: 1 / 5;
  grid-row: 5;
  padding: 5px;
}
.button-buy {
  background-color: #000000;
  border: 1px solid #000000;
  border-radius: 0;
  color: #ffffff;
}
.button-buy:hover {
  background-color: rgb(236, 236, 236);
  border: 1px solid #5a5a5a;
  color: #5a5a5a;
}
.images {
  grid-column: 1 / 5;
  grid-row: 1;
}
.active-image {
  height: 80%;
  position: relative;
}
.active-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.change-image-left-mobile {
  position: absolute;
  width: 50%;
  height: 100%;
  cursor: pointer;
}
.change-image-right-mobile {
  position: absolute;
  right: 0;
  width: 50%;
  height: 100%;
  cursor: pointer;
}
.change-image-left {
  display: none;
}
.change-image-right {
  display: none;
}
.all-images {
  height: 20%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  cursor: pointer;
  margin-top: 2px;
}
.one-image-wrapper {
  width: 25%;
  display:inline-block;
  white-space: nowrap;
  height: 100%;
}
.all-images img {
    width: 100%;
    height: auto;
}
.card {
  border-radius: 0;
  margin-right: 2px;
  margin-left: 2px;
  display: block;
  float: left;
  width: calc(20% - 4px);
}
.card-body {
  padding: 10px;
}
.card-size {
  cursor: pointer;
  border: 1px solid #000000;
}

.card-size-checked {
  border: 1px solid rgb(36, 36, 36);
  background-color: rgb(131, 69, 154);
}

.invalidSize {
  border: 1px solid red;
}

.card-size-inactive {
  background-color: rgba(125,125,125, 0.6);
}
.margin-bottom-15 {
  margin-bottom: 15px;
}

@media (min-width: 992px) {
  .wrapper {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 0;
    min-height: calc(100vh - 50px);
    grid-auto-rows: auto;
    grid-template-rows: none;
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 50px;
    margin-bottom: 0;
  }
  .info-section {
    grid-column: 5 / 7;
    grid-row: 1/4;
  }
  .product-title {
    grid-column: 5 / 7;
    grid-row: 1;
    padding-left: 0;
  }
  .product-description {
    grid-column: 5 / 7;
    grid-row: 2;
    height: auto;
    padding: 0;
    font-size: 0.75rem;
  }
  .sizes {
    grid-column: 5 / 7;
    grid-row: 3;
    grid-template-rows: 20%;
    padding-left: 0;
    padding-bottom: 40px;
  }
  .card {
    border-radius: 0;
    margin-right: 2px;
    margin-bottom: 2px;
    display: block;
    float: left;
  }
  .card-body {
    padding: 3px;
    font-size: 0.75rem;
  }
  .price {
    grid-column: 5;
    grid-row: 4;
    padding-left: 0;
    padding-bottom: 10px;
  }
  .buy-section {
    grid-column: 5;
    grid-row: 5;
    text-align: left;
    padding-left: 0;
    display: block;
  }

  .button-buy {
    font-size: 0.85rem;
  }
  .images {
    grid-column: 1 / 4;
    grid-template-columns: none;
    grid-template-rows: none;
    display: block;
    height: calc(100vh - 50px);
    grid-row: 1/7;
  }
  .active-image {
    height: 80%;
  }
  .change-image-left-mobile {
    display: none;
  }
  .change-image-right-mobile {
    display: none;
  }
  .change-image-left {
    position: absolute;
    width: 50%;
    height: 100%;
    cursor: pointer;
    display: block;
  }
  .change-image-right {
    position: absolute;
    right: 0;
    width: 50%;
    height: 100%;
    cursor: pointer;
    display: block;
  }

  .all-images {
    display: block;
    height: 20%;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
  }

  ::-webkit-scrollbar {
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #ffffFf;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #63135c;
    border-radius: 5px;
    height: 2px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>
